
export default {
  computed: {
    isDataLoading () {
      return this.isLoading > 0
    }
  },
  data () {
    return {
      isLoading: 0
    }
  },
  methods: {
    setIsLoading (val) {
      if (this.isLoading !== undefined) {
        this.isLoading += val ? 1 : -1
      }
    },
    addCommandParam (command, paramKey, paramVal) {
      command.params = command.params || {}
      command.params[paramKey] = paramVal
      return command
    },
    addCommandParamArray (command, paramKey, paramArray) {
      command.params = command.params || {}
      command.params[paramKey] = command.params[paramKey] || []
      command.params[paramKey].push(...paramArray)
      return command
    },
    addCommandParamObjectVal (command, paramKey, objectKey, val) {
      command.params = command.params || {}
      command.params[paramKey] = command.params[paramKey] || {}
      command.params[paramKey][objectKey] = val
      return command
    },
    addCommandParamArrayVal (command, paramKey, paramVal) {
      command.params = command.params || {}
      command.params[paramKey] = command.params[paramKey] || []
      for (let i = 2, l = arguments.length; i < l; i += 1) {
        if (!command.params[paramKey].includes(arguments[i])) {
          command.params[paramKey].push(arguments[i])
        }
      }
      return command
    }
  }
}
